import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    checkbox: {
        color: {
            primary: 'focus:ring-primary-700 text-primary-700',
        },
    },
}).checkbox;
